// src/components/Cards/CartsCard.jsx
import React from "react";
import PropTypes from "prop-types";
import { Box, Card, Typography } from "@mui/material";
import { Cell, Pie, PieChart, Tooltip } from "recharts";
import CircleIcon from "@mui/icons-material/Circle";
import Loader from "../../../../Inputs/Loader/Loader";
import {useNavigate} from "react-router-dom";

const renderCustomLegend = (data) => (
  <Box sx={{ display: "flex", gap: 1, flexDirection: "column", alignItems: "flex-start" }}>
    {data.map((entry, idx) => (
      entry.name !== "Total" && (
        <Box key={idx} sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <CircleIcon sx={{ color: entry.color, fontSize: 12 }} />
          <Typography sx={{ fontSize: 12 }}>{entry.name}</Typography>
          <Typography sx={{ fontSize: 12, fontWeight: 600 }}>{entry.value}</Typography>
        </Box>
      )
    ))}
  </Box>
);


const CartsCard = ({
  data,
  loading,
  error,
  icon,
  mainValue,
  popupLabel = '',
  mainLabel,
  subtitle,
  width,
  maxContainerWidth,
  height,
  innerRadius,
  outerRadius,
  navigatePath,
  colors,
}) => {
  const navigate = useNavigate();

  const CustomTooltip = ({ active, payload, label = popupLabel }) => {
    if (!active || !payload?.length) return null;
    const { percentage, value, color } = payload[0].payload;
    return (
      <Box sx={{ minWidth: 70, background: "#F3F3F3", borderRadius: 1, p: 1 }}>
        <Typography sx={{ fontWeight: 900, fontSize: 14, color }}>{percentage}</Typography>
        <Typography sx={{ fontSize: 12, color: "#1B3665", fontWeight: 600 }}>
          {value} {label}
        </Typography>
      </Box>
    );
  };


  if (error) {
    return <Typography color="error">Error: {error}</Typography>;
  }

  return (
    <Card sx={{ p: 2.5, maxWidth: maxContainerWidth, boxShadow: 'none', borderRadius: 2 }}>
      <Box onClick={() => {navigate(navigatePath)}}  sx={{ display: "flex", alignItems: "center", mb: 1.25, gap: 1, cursor: 'pointer' }}>
        {icon}
        <Typography sx={{ fontSize: 22, fontWeight: 600, color: "#1B3665" }}>
          {mainValue}
        </Typography>
        <Typography sx={{ fontSize: 22, fontWeight: 600, color: "#1B3665" }}>
          {mainLabel}
        </Typography>
      </Box>
      <Typography sx={{ fontSize: 14, color: "#A0AEC0", mb: 3 }}>
        {subtitle}
      </Typography>

      {loading ? (
        <Loader sx={{ width, height }} />
      ) : (
        <PieChart width={width} height={height}>
          <Pie
            data={data.filter((d) => d.name !== "Total")}
            cx="50%"
            cy="50%"
            innerRadius={50}
            outerRadius={90}
            fill="#8884d8"
            paddingAngle={0}
            dataKey="value"
            stroke="0"
          >
            {data.map((entry, idx) => (
              <Cell key={idx} fill={colors[idx % colors.length]} />
            ))}
          </Pie>
          <Tooltip content={<CustomTooltip />} />
        </PieChart>
      )}

      {renderCustomLegend(data)}
    </Card>
  );
};

CartsCard.defaultProps = {
  loading: false,
  error: null,
  icon: null,
  mainValue: 0,
  mainLabel: "",
  subtitle: "",
  width: 190,
  height: 230,
  maxContainerWidth: 203,
  navigatePath: '',
  innerRadius: 50,
  outerRadius: 90,
  colors: ["#89D8C2", "#E89585", "#B6CFF1", "#32a852", "#328da8", "#3012de"],
};

export default CartsCard;
